module.exports = global.config = {
    apiKey : 'IPPWCC2CUGX8Q4H55JTD9VDZMCT7LT6L',
    domain_url:"https://www.kimiagoldgallery.com",
    //domain_url:"https://dev.kimiagoldgallery.com",
    //domain_url:"http://localhost:3000",
    webhesab_url:"http://erp.kimiagoldgallery.com"
}